<template v-slot:LandingPage>
  <div class="volumes-abo-option">
    <fieldset :class="{ promoBadge: getPromotionsForOption(selectableAboOptionKeys).length > 0 }">
      <div role="radiogroup" tabindex="-1" class="abo-group" :class="'options-' + selectableAboOptions.length">
        <label v-for="option in selectableAboOptions" :key="option.optionId" :class="labelClasses(option)">
          <div class="badge" :class="[option.badgeColor, { 'static': !option.dynamicBadge }]" v-if="isBadgeActive(option) && option.badgeText">{{option.badgeText}}</div>
          <input class="sr-only" type="radio" v-model="selectedOption"
                 :value=option.optionId
                 :id=option.optionId
                 name="aboOptionSelection"
                 @change="setAboOption(selectedOption)"
          >
          <div class="option">
            <span :class="{'badge-amount': isBadgeActive(option)}" :data-prid="'option-' + option.optionId" v-html="formatAmount(option)"></span>
            <span v-if="option.basisVolume !== option.amount" class="strikeVolume" aria-hidden="true" v-html="formatVolume(option)"></span>
            <span v-if="option.showPriceInOption" class="price" aria-hidden="true">
              <span v-if="showPriceStarts">ab </span>
              <span>{{priceWithoutEuro(targetTariff.basicFee + option.price)}} </span>
              <span>€</span>
            </span>
          </div>
        </label>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import price from '@/mixins/formatters/price'
import date from '@/mixins/validators/date'

export default {
  name: 'VolumesAboOption',
  data () {
    return {
      selectedOption: ''
    }
  },
  mounted () {
    this.prefillSelectedOption()
  },
  mixins: [
    preFilledInput('selected', 'selectedAboOptionId'),
    price,
    date
  ],
  props: {
    targetTariff: {
      type: Object,
      default: null
    },
    availableAboOptions: {
      type: Array,
      default: () => []
    },
    volumePromotions: {
      type: Array,
      default: () => []
    },
    showPriceStarts: {
      type: Boolean,
      default: true
    },
    process: {
      type: String,
      default: 'ordering'
    }
  },
  methods: {
    labelClasses (option) {
      const classes = []

      // needed for promo color
      if (option.promoVolume > 0) {
        classes.push('promotion')
      }
      if (option.cssClass) {
        classes.push(option.cssClass)
      }
      // color handling
      if (this.isBadgeActive(option)) { // Badge color overwrites usual color or promo color - not anymore...
        classes.push('badge-label')
      }
      if (option.promoVolume > 0) {
        classes.push(option.promoColor)
      } else {
        classes.push(option.color)
      }

      // active option
      if (option.optionId === this.selectedOption) {
        classes.push('active')
      }

      return classes
    },
    addUpPromoVolumes (promos) {
      let volume = 0
      if (promos && promos.length > 0) {
        promos.forEach(promo => {
          if (promo.incentives) {
            promo.incentives.forEach(incentive => {
              volume += incentive.amount
            })
          }
        })
      }
      return volume
    },
    setAboOption (selected) {
      const option = this.findTarifOption([selected])
      this.$store.commit('checkoutv2/' + this.process + '/_cart/setSelectedTariffoptionIds', (selected !== 'none' && option[0] !== undefined) ? [option[0]?.tariffoptionId] : [])
    },
    prefillSelectedOption () {
      const params = new URLSearchParams(window.location.search)
      const optionParam = params.get('option')?.toLowerCase() || ''
      const preselectionURL = this.selectableAboOptions.find(e => e?.url?.toLowerCase() === optionParam)

      const preselectionCMS = this.selectableAboOptions.find(option => option.preselectOption === '1')

      if (preselectionURL && optionParam) { // primary preselection via url parameter "option"
        this.selectedOption = preselectionURL.optionId
        this.setAboOption(this.selectedOption)
        params.delete('option')
        const newUrl = params.toString() ? `${location.pathname}?${params.toString()}` : location.pathname
        history.replaceState('', '', newUrl)
      } else if (preselectionCMS) { // secondary preselection cms configuration
        this.selectedOption = preselectionCMS.optionId
        this.setAboOption(this.selectedOption)
      } else { // fallback to stored option or 'none' as default
        this.selectedOption = this.selected ?? 'none'
      }
    },
    getPromotionsForOption (optionIds) {
      return this.volumePromotions.filter(promo => {
        const promoOptionIds = promo.criteria?.tariffoptionIds || []
        return promoOptionIds.find(id => optionIds.includes(id))
      })
    },
    isBadgeActive (option) {
      return option.showBadge && this.todayIsBetweenDates(option.badgeStart, option.badgeEnd)
    },
    toDate (string) {
      let datum = null
      if (string && string.length === 10) {
        const parts = string.split('.')
        if (parts.length === 3) {
          datum = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]), 0, 0, 0)
        }
      }
      return datum
    },
    formatAmount: function (option) {
      return this.processHTML(`${option.amount} <span class="unit">GB</span>`)
    },
    formatVolume: function (option) {
      return this.processHTML(`${option.basisVolume} <span class="unit">GB</span>`)
    }
  },
  computed: {
    ...mapGetters('checkout/tariff', [
      'findTarifOption',
      'defaultTariff'
    ]),
    ...mapGetters('promotion', ['presalesInclusivePromotion']),
    selectedAboOptionId: function () {
      const selectedTariffOptionIds = this.$store.getters['checkoutv2/' + this.process + '/_cart/selectedTariffOptionIds'] // used in propositions
      return selectedTariffOptionIds.length > 0 ? selectedTariffOptionIds[0] : null
    },
    selectableAboOptions: function () {
      const today = new Date()
      today.setHours(0, 0, 0, 0) // Normalize today's date for comparison

      return this.availableAboOptions
        .filter(element => element.optionId === 'none' || this.findTarifOption([element.optionId]).length === 1)
        .map(option => {
          if (option.optionId === 'none') {
            option.promoVolume = this.basisPromoVolume
            option.basisVolume = this.basisVolume
            option.amount = option.basisVolume + option.promoVolume
            option.price = 0

            // wenn kuenstliches Streichvolumen im CMS gesetzt ist, dann wird es vom basisVolume abgezogen, um Streich-GB zu erzwingen
            if (option.strikeAmount && parseInt(option.strikeAmount)) {
              option.basisVolume -= parseInt(option.strikeAmount)
            }
            return option
          }

          const tariffOption = this.findTarifOption([option.optionId])[0]
          const promos = this.getPromotionsForOption([option.optionId])
          let volume = 0
          let promoVolume = 0

          if (tariffOption?.volumes?.[0]?.amount > 0) {
            volume += tariffOption.volumes[0].amount
          }

          promoVolume = this.addUpPromoVolumes(promos)
          option.price = tariffOption?.price
          option.promoVolume = this.basisPromoVolume + promoVolume
          option.basisVolume = this.basisVolume + volume
          option.amount = option.basisVolume + option.promoVolume

          // wenn kuenstliches Streichvolumen im CMS gesetzt ist, dann wird es vom basisVolume abgezogen, um Streich-GB zu erzwingen
          if (option.strikeAmount && parseInt(option.strikeAmount)) {
            option.basisVolume -= parseInt(option.strikeAmount)
          }
          return option
        })
    },
    selectableAboOptionKeys: function () {
      return this.selectableAboOptions.filter(option => option.optionId !== 'none').map(option => option.optionId)
    },
    basisVolume: function () {
      if (this.targetTariff && this.targetTariff.volumes && this.targetTariff.volumes[0]) {
        return this.targetTariff.volumes[0].amount || 20
      } else if (this.defaultTariff && this.defaultTariff.volumes && this.defaultTariff.volumes[0]) {
        return this.defaultTariff.volumes[0].amount || 20
      }
      return 20
    },
    basisPromoVolume: function () {
      const promos = this.volumePromotions.filter(promo => {
        const optionIds = promo.criteria?.tariffoptionIds || []
        return optionIds.length === 0
      })
      return this.addUpPromoVolumes(promos)
    }
  }
}
</script>
